import { useApiQuery } from '@common/hooks';
import { SkipOrArgs } from '@common/types/queryState';
import { useSelectedProductionId } from '@features/productions';
import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';
import { useGetClipTracksQuery } from '../api';
import { GetClipMediaArgs } from '../types';
import { mergeWithDefault } from '@common/utils/mergeWithDefault';
import { DEFAULT_TRACK } from '../types/media';

export interface UseClipTracksArgs {
    mediaObjectId: string;
    moiId: string;
}

export const useClipTracks = (args: SkipOrArgs<UseClipTracksArgs>) => {
    const productionId = useSelectedProductionId();

    const queryArgs: SkipOrArgs<GetClipMediaArgs> = useMemo(() => {
        if (
            args === skipToken ||
            !productionId ||
            !args.mediaObjectId ||
            !args.moiId
        )
            return skipToken;

        return {
            ...args,
            productionId,
        };
    }, [args, productionId]);

    const { data, ...queryResult } = useApiQuery(
        useGetClipTracksQuery,
        queryArgs,
    );

    return {
        data: Object.values(mergeWithDefault(data, [DEFAULT_TRACK])),
        ...queryResult,
    };
};
